import { ChartBar } from "@phosphor-icons/react";

export function UsageBadge({ usage, isAdmin }) {
  if (!usage || isAdmin) return null;

  const hasFairUse = usage.fair_use_limit;
  const hasHardLimit = usage.generations_limit;

  if (hasHardLimit) {
    const pct = Math.min((usage.generations_used / usage.generations_limit) * 100, 100);
    const ratio = usage.generations_used / usage.generations_limit;
    const barColor = ratio >= 1 ? '#EF4444' : ratio >= 0.8 ? '#F59E0B' : ratio >= 0.5 ? '#F59E0B' : '#FF4400';
    return (
      <div className="hidden sm:flex items-center gap-2 px-2.5 py-1 rounded-full bg-[var(--bg-raised)] border border-[var(--border)] relative" data-testid="usage-badge">
        <span className="text-[10px] font-['JetBrains_Mono'] text-[var(--text-muted)]">
          {usage.generations_used}/{usage.generations_limit}
        </span>
        <div className="w-12 h-1.5 bg-[var(--bg-hover)] rounded-full overflow-hidden">
          <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: barColor }} />
        </div>
        {ratio >= 0.8 && ratio < 1 && (
          <div className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-amber-500 animate-pulse" data-testid="usage-pulse-dot" />
        )}
      </div>
    );
  }

  if (hasFairUse && usage.fair_use_warning) {
    const pct = Math.min((usage.generations_used / usage.fair_use_limit) * 100, 100);
    return (
      <div className="hidden sm:flex items-center gap-2 px-2.5 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 relative" data-testid="usage-badge-fair-use">
        <span className="text-[10px] font-['JetBrains_Mono'] text-amber-400">
          {usage.generations_used.toLocaleString()}/{(usage.fair_use_limit / 1000).toFixed(0)}k
        </span>
        <div className="w-12 h-1.5 bg-amber-500/20 rounded-full overflow-hidden">
          <div className="h-full rounded-full bg-amber-500 transition-all" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  return null;
}
